import Player from './Player';

export default class PlayerManager {

    relatedScene: Phaser.Scene;
    players: Player[];

    constructor(scene: Phaser.Scene) {
        this.relatedScene = scene;
        this.players = [];
    }

    add(id: string, type: string, color: number) {
        this.players.push(
            new Player(id, this.relatedScene, type, color)
        );
    }

    public byId(id: string): Player {
        const player = this.players.find((player: Player) => {
            return player.id == id;
        });
        if (!player) {
            throw new Error(`Player Id ${id} not found`);
        }
        return player;
    }
}